



















import { Component, Vue } from "vue-property-decorator";
import { Prop } from "@rocketbase/vue-extra-decorators";
@Component
export default class BottomNav extends Vue {
  @Prop({ default: "overview", model: true })
  private activeItem!: string;

  private goTo(page: string) {
    if (page === "overview") this.$router.replace("/");
    else if (page === "lockers") this.$router.replace("/lockers");
    else if (page === "history") this.$router.replace("/history");

    //this.activeItem = page;
    //this.$emit("change", page);
  }
}
